var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6755 16C31.6755 12.8354 30.7466 9.74193 29.0063 7.11071C27.2659 4.47949 24.7923 2.42873 21.8982 1.21778C19.0042 0.00682339 15.8196 -0.309934 12.7474 0.307564C9.6751 0.925062 6.85309 2.44908 4.6382 4.68688C2.42332 6.92469 0.915043 9.77577 0.304125 12.8796C-0.306793 15.9834 0.00708252 19.2005 1.20606 22.1241C2.40503 25.0477 4.43525 27.5464 7.03998 29.3043C9.6447 31.0622 12.7069 32.0003 15.8394 32C20.1119 32 23.3639 30.5308 26.2659 27.961C26.3407 27.8892 26.4376 27.8455 26.5404 27.837C26.6433 27.8286 26.7459 27.8559 26.8312 27.9145L30.9311 31.2579C31.0022 31.3076 31.0854 31.3369 31.1717 31.3425C31.258 31.3481 31.3442 31.3299 31.421 31.2898C31.4978 31.2497 31.5624 31.1893 31.6078 31.1149C31.6532 31.0406 31.6778 30.9552 31.6788 30.8678C31.6772 28.801 31.6755 17.9988 31.6755 16ZM15.7688 24.7205C13.4795 24.6951 11.2937 23.7528 9.6916 22.1007C8.08946 20.4485 7.20188 18.2215 7.22379 15.9087C7.23365 14.8197 7.30595 7.80743 7.30595 7.80743C7.30138 7.75768 7.31172 7.70769 7.33565 7.66395C7.35957 7.62022 7.39596 7.58477 7.44009 7.56221C7.48422 7.53965 7.53406 7.53102 7.58311 7.53745C7.63215 7.54388 7.67815 7.56507 7.71513 7.59826L9.93189 9.44429C9.9781 9.47626 10.0337 9.49138 10.0896 9.48716C10.1454 9.48294 10.1982 9.45962 10.2392 9.42105C11.8364 8.03819 13.6128 7.26292 15.9446 7.28118C17.0847 7.28289 18.2132 7.51276 19.2648 7.95749C20.3165 8.40223 21.2706 9.05303 22.0719 9.87232C22.8733 10.6916 23.506 11.6631 23.9336 12.7308C24.3613 13.7985 24.5753 14.9412 24.5633 16.093C24.5514 17.2447 24.3137 18.3826 23.8641 19.441C23.4144 20.4994 22.7617 21.4574 21.9435 22.2595C21.1254 23.0617 20.158 23.6922 19.0974 24.1146C18.0367 24.537 16.9037 24.7429 15.7638 24.7205H15.7688Z",
    fill: "url(#paint0_linear_28_14)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_14",
    x1: 12.0336,
    y1: -6.144,
    x2: 19.7872,
    y2: 38.0659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74CBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#69C5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#4AB5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#199CCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0692C8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e51a597d2741642ca33b2bcdfc004cf1.svg";
export { ForwardRef as ReactComponent };